import React from 'react'
import PropTypes from 'prop-types'

import DebtSchedule from './DebtSchedule'
import BalanceSheet from './BalanceSheet'
import LoanPayments from './LoanPayments'
import MarginAnalysis from './MarginAnalysis'
import FadeInWrapper from '../common/FadeInWrapper'
import styled from 'styled-components'

const EditUseOfProceedsLink = styled.a`
  cursor: pointer;
`
const Exclamation = styled.i`
  color: #dd6a01;
  margin-right: 3px;
`

export default class StaticTables extends React.Component {
  static propTypes = {
    entity: PropTypes.object.isRequired,
    guarantors: PropTypes.arrayOf(PropTypes.object),
    lastTaxYear: PropTypes.number,
    monthsRemainingCutoff: PropTypes.number,
    name: PropTypes.string.isRequired,
    refetch: PropTypes.func,
    resourceType: PropTypes.string.isRequired,
    rid: PropTypes.number,
    useOfFund: PropTypes.shape({
      businessAcquisition: PropTypes.number,
      hiring: PropTypes.number,
      inventory: PropTypes.number,
      marketing: PropTypes.number,
      newEquipment: PropTypes.number,
      operationalCosts: PropTypes.number,
      realEstateMortgageRefinance: PropTypes.number,
      realEstatePurchase: PropTypes.number,
      refinance: PropTypes.number,
      remaining: PropTypes.number,
      total: PropTypes.number
    }),
    years: PropTypes.object
  }
  renderDebtSchedule = () => {
    const { rid, name, resourceType, monthsRemainingCutoff, refetch } = this.props
    if (resourceType === 'Business') {
      return (
        <DebtSchedule
          financialReviewRefetch={refetch}
          name={name}
          rid={rid}
          monthsRemainingCutoff={monthsRemainingCutoff}
        />
      )
    }
  }
  renderBalanceSheet = () => {
    const { name, resourceType, refetch, entity } = this.props
    if (resourceType === 'Business' || resourceType === 'Guarantor') {
      let assets, liabilities, balanceSheet, footerTitle, title
      let balanceSheetUrl = null
      if (resourceType === 'Business') {
        assets = [
          { title: 'Total Checking/Savings', key: 'checkingSaving' },
          { title: 'Other Current Assets', key: 'cashEquivalents' },
          { title: 'Fixed Assets', key: 'fixedAssets' }
        ]
        liabilities = [
          { title: 'Current Liabilities', key: 'currentLiabilities' },
          { title: 'Non-Current Liabilities', key: 'nonCurrentLiabilities' },
          { title: null, key: null }
        ]
        balanceSheet = entity.balanceSheet
        footerTitle = 'Total Equity'
        title = `Interim Balance Sheet for ${name}`
        balanceSheetUrl = entity.balanceSheetUrl
      } else if (resourceType === 'Guarantor') {
        assets = [
          { title: 'Cash in Bank Accounts', key: 'cashInBanks' },
          { title: 'Marketable Securities', key: 'marketableSecurities' },
          { title: 'Cash Surrender Value of Life Insurance', key: 'lifeInsurance' },
          { title: 'Retirement Accounts', key: 'retirementAccounts' },
          { title: 'Real Estate Owned', key: 'realEstate' },
          { title: 'Other Assets', key: 'otherAssets' }
        ]
        liabilities = [
          { title: 'Credit Cards', key: 'creditCards' },
          { title: 'Installment Loans', key: 'installmentLoans' },
          { title: 'Real Estate Loans', key: 'otherMortgages' },
          { title: 'Taxes Owed', key: 'taxesOwed' },
          { title: 'Other Liabilities', key: 'otherLiabilities' },
          { title: null, key: null }
        ]
        balanceSheet = this.props.entity.personalFinancial
        footerTitle = 'Net Worth'
        title = `Personal Financial Statement for ${name}`
      }
      if (balanceSheet) {
        return (
          <BalanceSheet
            assets={assets}
            liabilities={liabilities}
            balanceSheet={balanceSheet}
            footerTitle={footerTitle}
            name={name}
            title={title}
            refetch={refetch}
            resourceType={resourceType}
            balanceSheetUrl={balanceSheetUrl}
          />
        )
      }
    }
  }
  renderLoanPayments = () => {
    const { entity, resourceType, lastTaxYear, name, guarantors } = this.props
    if (resourceType === 'Business') {
      return null
    }
    const spouse = guarantors.find(g => g.rid === entity.spouseId)
    const guarantor = guarantors.find(g => g.rid === entity.rid)
    return (
      <LoanPayments
        spouse={spouse}
        guarantor={guarantor}
        lastTaxYear={lastTaxYear}
        name={name}
      />
    )
  }
  renderMarginAnalysis = () => {
    const { years, name, resourceType } = this.props
    const { cashflowData, fiscalYears } = this.props.entity
    const segments = [
      {
        title: 'Year-Over-Year Growth',
        key: 'growth',
        categories: [
          { title: 'Revenue Change', key: 'gross_revenue' },
          { title: 'Net Profit Change', key: 'net_profit' },
          { title: 'Cash Flow Change', key: 'cash_available_for_debt_service' }
        ]
      },
      {
        title: 'Margin Analysis',
        key: 'margin',
        categories: [
          { title: 'Gross Margin', key: 'gross_revenue' },
          { title: 'Net Margin', key: 'net_profit' },
          { title: 'Cash Flow Margin', key: 'cash_available_for_debt_service' }
        ]
      }
    ]
    if (resourceType === 'Business') {
      return (
        <MarginAnalysis
          fiscalYears={fiscalYears}
          segments={segments}
          years={years}
          cashflowData={cashflowData}
          name={name}
        />
      )
    }
  }
  renderUseOfProceedNotification = () => {
    const { total, remaining } = this.props.useOfFund
    if (total > 0 && remaining !== 0) {
      return (
        <span id="use_of_proceeds_notification">
          <Exclamation className="fa fa-exclamation-circle" />
          The Use of Proceeds breakdown is not equal to the current loan amount.&nbsp;
          <EditUseOfProceedsLink onClick={this.props.toggleUseOfProceeds}>Please update the Use of Proceeds.</EditUseOfProceedsLink>
        </span>
      )
    }
  }
  render() {
    return (
      <FadeInWrapper>
        {this.renderDebtSchedule()}
        {this.renderUseOfProceedNotification()}
        {this.renderLoanPayments()}
        {this.renderMarginAnalysis()}
        {this.renderBalanceSheet()}
      </FadeInWrapper>
    )
  }
}
